import React from 'react';
import { useNavigate } from 'react-router-dom';

import { ROUTES } from '@constants/routes';
import PageHeader, { PageBackground } from '@domain/page-header';
import LoginForm from '@features/login/login-form';
import { useLogin } from '@services/auth';
import { isDev } from '@utils/is-dev';

function ElearningWpOnSiteLoginPage() {
  const { mutateAsync: loginMutate, isPending } = useLogin();
  const navigate = useNavigate();

  const onSubmit = async ({
    username,
    password
  }: {
    username: string;
    password: string;
  }) => {
    try {
      await loginMutate({ username, password });
      navigate(ROUTES.EWOS_MVE);
    } catch (e) {}
  };

  return (
    <PageBackground>
      <PageHeader />
      <LoginForm
        onSubmit={onSubmit}
        isPending={isPending}
        defaultValues={
          isDev ? { username: 'kbu.sectran', password: 'Knorr2026' } : undefined
        }
      />
    </PageBackground>
  );
}

export default ElearningWpOnSiteLoginPage;
